import React from 'react';
import './Banner.css';

import { Button, Heading } from '../../../components';



const Banner = () => {

  return (
    <section className="banner">
      <div className='content'>

        <Heading title={"Discover the Ideal Woodwork Solutions for Your Space"} subTitle={"Elevate Your Home Interior"} linear sideHeading />
        <Button link={"Get-Quote"} title={"Get A Quote"} />

      </div>
    </section>
  );

};

export default Banner;